import styled from 'styled-components';

const ListStyled = styled.ul.attrs({
  className: 'component__List',
})`
  padding-left: 1rem;
`;

export default ListStyled;
